export const ORDER_EXCHANGE = {
    QUERY_TASK_LIST: 'QUERY_TASK_LIST',
    QUERY_TASK_LIST_SUCCESS: 'QUERY_TASK_LIST_SUCCESS',
    QUERY_TASK_LIST_FAIL: 'QUERY_TASK_LIST_FAIL',

    CREATE_TASK: 'CREATE_TASK',
    CREATE_TASK_SUCCESS: 'CREATE_TASK_SUCCESS',
    CREATE_TASK_FAIL: 'CREATE_TASK_FAIL',

    FORWARD_ORDER: 'FORWARD_ORDER',
    FORWARD_ORDER_SUCCESS: 'FORWARD_ORDER_SUCCESS',
    FORWARD_ORDER_FAIL: 'FORWARD_ORDER_FAIL',

    QUERY_TO_BE_FORWARD_ORDERS: 'QUERY_TO_BE_FORWARD_ORDERS',
    QUERY_TO_BE_FORWARD_ORDERS_SUCCESS: 'QUERY_TO_BE_FORWARD_ORDERS_SUCCESS',
    QUERY_TO_BE_FORWARD_ORDERS_FAIL: 'QUERY_TO_BE_FORWARD_ORDERS_FAIL',

    COMPLETE_TASK: 'COMPLETE_TASK',
    COMPLETE_TASK_SUCCESS: 'COMPLETE_TASK_SUCCESS',
    COMPLETE_TASK_FAIL: 'COMPLETE_TASK_SUCCESS',

    QUERY_TASK_DETAIL: 'QUERY_TASK_DETAIL',
    QUERY_TASK_DETAIL_SUCCESS: 'QUERY_TASK_DETAIL_SUCCESS',
    QUERY_TASK_DETAIL_FAIL: 'QUERY_TASK_DETAIL_FAIL',

    PRINT_ORDER_LABEL: 'PRINT_ORDER_LABEL',
    PRINT_ORDER_LABEL_SUCCESS: 'PRINT_ORDER_LABEL_SUCCESS',
    PRINT_ORDER_LABEL_FAIL: 'PRINT_ORDER_LABEL_FAIL',


    //BBC Order Exchange
    SEARCH_DETAILED_INFO: 'SEARCH_DETAILED_INFO',
    SEARCH_DETAILED_INFO_SUCCESS: 'SEARCH_DETAILED_INFO_SUCCESS',
    SEARCH_DETAILED_INFOL_FAIL: 'SEARCH_DETAILED_INFOL_FAIL',

    DOWNLOAD_DETAILED_INFO: 'DOWNLOAD_DETAILED_INFO',
    DOWNLOAD_DETAILED_INFOL_SUCCESS: 'DOWNLOAD_DETAILED_INFOL_SUCCESS',
    DOWNLOAD_DETAILED_INFO_FAIL: 'DOWNLOAD_DETAILED_INFO_FAIL',
    //
    SEARCH_SUMMARY_INFO: 'SEARCH_SUMMARY_INFO',
    SEARCH_SUMMARY_INFOL_SUCCESS: 'SEARCH_SUMMARY_INFOL_SUCCESS',
    SEARCH_SUMMARY_INFO_FAIL: 'SEARCH_SUMMARY_INFO_FAIL',
    
    DOWNLOAD_SUMMARY_INFO: 'DOWNLOAD_SUMMARY_INFO',
    DOWNLOAD_SUMMARY_INFO_SUCCESS: 'DOWNLOAD_SUMMARY_INFO_SUCCESS',
    DOWNLOAD_SUMMARY_INFO_FAIL: 'DOWNLOAD_SUMMARY_INFO_FAIL',
    //
    SEARCH_TIMING_INFO: 'SEARCH_TIMING_INFO',
    SEARCH_TIMING_INFO_SUCCESS: 'SEARCH_TIMING_INFO_SUCCESS',
    SEARCH_TIMING_INFO_FAIL: 'SEARCH_TIMING_INFO_FAIL',

    DOWNLOAD_TIMING_INFO: 'DOWNLOAD_TIMING_INFO',
    DOWNLOAD_TIMING_INFO_SUCCESS: 'DOWNLOAD_TIMING_INFO_SUCCESS',
    DOWNLOAD_TIMING_INFO_FAIL: 'DOWNLOAD_TIMING_INFO_FAIL',
    //
    SEARCH_USER_INFO: 'SEARCH_USER_INFO',
    SEARCH_USER_INFO_SUCCESS: 'SEARCH_USER_INFO_SUCCESS',
    SEARCH_USER_INFO_FAIL: 'SEARCH_USER_INFO_FAIL',

    DOWNLOAD_USER_INFO: 'DOWNLOAD_USER_INFO',
    DOWNLOAD_USER_INFO_SUCCESS: 'DOWNLOAD_USER_INFO_SUCCESS',
    DOWNLOAD_USER_INFOL_FAIL: 'DOWNLOAD_USER_INFOL_FAIL',

    CREATE_AUTO_TASK: 'CREATE_AUTO_TASK',
    CREATE_AUTO_TASK_SUCCESS: 'CREATE_AUTO_TASK_SUCCESS',
    CREATE_AUTO_TASK_FAIL: 'CREATE_AUTO_TASK_FAIL'
}